import React from "react";
import type {FunctionComponent} from "react";
import {WhenDevice} from "../../../../modules/conditional/when-device/WhenDevice";

export interface IWhenDeviceTypeMobile{
  not?: boolean;
}

export const WhenDeviceTypeMobile: FunctionComponent<IWhenDeviceTypeMobile> = ({children, not}) => {
  if (!!not){
    return <WhenDevice blockedType={'mobile'}>{children}</WhenDevice>;
  }
  return <WhenDevice allowedType={'mobile'}>{children}</WhenDevice>;
}
